export default __webpack_public_path__ + "static/media/logoTopii.06a3e318.svg";